import {DeliveryBadgeIcon, Grid, ShieldBadgeIcon, TimeBadgeIcon} from '@logistics-frontend/blocks'
import {Divider} from '@logistics-frontend/blocks/lpc/divider'
import {useI18n} from '@logistics-frontend/core/i18n'
import {applyPlaceholder} from '@logistics-frontend/core/i18n/translate'
import {useTariff} from '@yandex-taxi/react-integration-api'
import React, {useMemo} from 'react'

import {Tariff} from '../../consts'
import {classes} from './Disclaimer.classes'

const Disclaimer: React.FC = () => {
  const t = useI18n()
  const [{value: tariff}] = useTariff()

  const disclaimers = useMemo(() => {
    const disclaimer: string | undefined = {
      [Tariff.CARGO]: t('order_cargo_disclaimer_texts', {fallBackToKey: false}),
      [Tariff.EXPRESS]: t('order_express_disclaimer_texts', {fallBackToKey: false}),
      [Tariff.COURIER]: t('order_courier_disclaimer_texts', {fallBackToKey: false}),
    }[tariff]

    return disclaimer?.split('\n').map(value =>
      applyPlaceholder(value, {
        DeliveryBadgeIcon: <DeliveryBadgeIcon className={classes.icon} />,
        ShieldBadgeIcon: <ShieldBadgeIcon className={classes.icon} />,
        TimeBadgeIcon: <TimeBadgeIcon className={classes.icon} />,
      }),
    )
  }, [t, tariff])

  if (disclaimers?.length > 0) {
    return (
      <>
        <Grid spacing={1} container>
          <Grid className={classes.title} xs={12} item>
            {t('order.form.disclaimer.included_in_price', 'Включено в стоимость')}
          </Grid>
          {disclaimers.map((value, index) => (
            <Grid key={index} alignItems="center" wrap="nowrap" xs={12} container item>
              {value}
            </Grid>
          ))}
        </Grid>
        <Divider className={classes.divider} />
      </>
    )
  }

  return null
}

export default Disclaimer
